/** Public asset path for files in `public/` (Vite serves at site root). */
export function publicAssetUrl(src) {
  const path = src.startsWith('/') ? src : `/${src}`;
  const base = (typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL) || '/';
  if (!base || base === '/') return path;
  return `${base.replace(/\/$/, '')}${path}`;
}
